module.exports = __webpack_public_path__ + "img/yogiyo.4e6c4f47.png";